import React, { Component } from 'react'
import { connect } from 'react-redux'
import * as actions from '../actions'
import Forms from './Forms'
import { Row, Col } from 'antd'
import { Redirect } from 'react-router-dom'
import Breadcrumb from './../../../shared/components/Breadcrumbreport'
import { GeneralStyledContent } from '../../../../styled/common-styled'
import AuthorizeComponent from './../../../auth/components/AuthorizeComponent'

class Index extends Component {
  loadScoresummary = (values, loading) => {
    values = {
      ...values,
      type_file: 'excel',
    }
    this.props.loadScoresummary(values, loading)
  }

  loadVehicle = (vehicletypeID, loading_vehicle) => {
    this.props.loadVehicle(vehicletypeID, loading_vehicle)
  }

  render() {
    const { vehicleLists, scoresummaryLoading } = this.props.scoresummary
    return (
      <AuthorizeComponent {...this.props} matching_name="ScoresummaryReport">
        <GeneralStyledContent>
          <Row gutter={24}>
            <Col span={24}>
              {/* <Breadcrumb
                match={this.props.match}
                sub_menu="behavior"
                style={{ margin: '0px 0px 14px 10px' }}
              /> */}
            </Col>
          </Row>
          <Forms
            onSubmit={this.loadScoresummary}
            vehicleLists={vehicleLists}
            scoresummaryLoading={scoresummaryLoading}
            loadVehicle={this.loadVehicle}
            auth={this.props.profile}
          />
        </GeneralStyledContent>
      </AuthorizeComponent>
    )
  }
}

const mapStateToProps = ({ scoresummary, auth: { profile } }) => ({
  scoresummary,
  profile,
})

const mapDispatchToProps = {
  loadScoresummary: actions.loadScoresummary.request,
  loadVehicle: actions.loadVehicle.request,
}

export default connect(mapStateToProps, mapDispatchToProps)(Index)
